import { Button } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { DraftStatus } from "authoring/lib/enum/draft-status.mjs"
import { isLockedToLegacy } from "authoring/lib/enum/project-phase.mjs"
import { useDemand } from "lib/authorization/use-demand"
import { navigateSequentialReview } from "../utilities/project-navigation"
import Iconify from "minimals-template/components/Iconify"
import { AUTHORING_REVIEW_SCHEDULES_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"

export function StartReviewButton() {
    const { target: project, resolvedSchedules = [] } = useBoundContext()
    const canReview = useDemand(AUTHORING_REVIEW_SCHEDULES_DEMAND)

    if (!canReview) return null
    if (isLockedToLegacy(project?.phase)) return null

    const submittedSchedules = resolvedSchedules.filter(isSubmitted)
    if (!submittedSchedules.length) return null

    const firstSubmitted = submittedSchedules[0]

    return (
        <Button
            variant="outlined"
            startIcon={<Iconify icon="mdi:clipboard-check-outline" />}
            onClick={handleClick}
            data-cy="start-review-button"
        >
            Review All ({submittedSchedules.length})
        </Button>
    )

    function handleClick() {
        navigateSequentialReview({ projectId: project?.id, scheduleId: firstSubmitted.id })
    }
}

function isSubmitted(schedule) {
    return schedule?.isDraft && schedule?.status === DraftStatus.SUBMITTED
}
